import { useState } from "react";
import { Filter } from "lucide-react";
import { FiltersModal } from "./FiltersModal";

interface Props {
  sourceRef: { kind: string; params: Record<string, unknown> };
  onRerun: (
    sourceRef: { kind: string; params: Record<string, unknown> },
    values:    Record<string, string | string[]>,
  ) => void;
  disabled: boolean;
}

/**
 * The "Filters…" button that sits next to the refine input on charts
 * produced by `cognos.report.run`. Owns the open/close state of the
 * FiltersModal so the modal disappears cleanly when the user submits
 * or cancels.
 */
export function RerunWithFiltersButton({ sourceRef, onRerun, disabled }: Props) {
  const [open, setOpen] = useState(false);
  const searchPath = typeof sourceRef.params["searchPath"] === "string"
    ? (sourceRef.params["searchPath"] as string)
    : "";
  if (!searchPath) return null;

  const initialValues =
    sourceRef.params["parameters"] && typeof sourceRef.params["parameters"] === "object"
      ? (sourceRef.params["parameters"] as Record<string, string | string[]>)
      : undefined;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        disabled={disabled}
        aria-label="Re-run with filters"
        title="Re-run the report with different prompt values"
        className="flex-none inline-flex h-7 items-center gap-1 rounded-full border border-slate-200 bg-white px-3 text-xs text-slate-700 transition hover:border-slate-300 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <Filter className="h-3 w-3" aria-hidden="true" />
        Filters…
      </button>
      {open && (
        <FiltersModal
          searchPath={searchPath}
          initialValues={initialValues}
          onClose={() => setOpen(false)}
          onSubmit={(values) => {
            setOpen(false);
            onRerun(sourceRef, values);
          }}
        />
      )}
    </>
  );
}
